export function rem100(n?: number | null): string {
    return Number.isFinite(n) && n != null ? (n % 100).toString() : ''
}